import { useState, useEffect } from "react"
import { useAddNewLessonMutation } from "./lessonsApiSlice"
import { useNavigate, useParams } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faSave } from "@fortawesome/free-solid-svg-icons"
import TimeLeft from "../../partial/TimeLeft"



const NewLessonForm = (props) => {
    const {groupId, type} = useParams()
    const [addNewLesson, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useAddNewLessonMutation()

    const navigate = useNavigate()

    const [title, setTitle] = useState('')
    const [group, setGroup] = useState(groupId!='0'?groupId:'')

    const [dt, setDt] = useState(new Date())
    const [fromDate, setFromDate] = useState(new Date())
    const [toDate, setToDate] =useState(new Date(new Date().getTime() + 15*60000))
    const [active, setActive] = useState(true)
    const [numberOfLessons, setNumberOfLessons] = useState(3)


    useEffect(() => {
        if (isSuccess) {
            setTitle('')          
            navigate(`/${type}/${groupId}/lessons`)
        }
    }, [isSuccess, navigate])





    const canSave = [title, group, dt, fromDate, toDate].every(Boolean) && !isLoading

    const onSaveLessonClicked = async (e) => {
        e.preventDefault()
        if (canSave) {
            await addNewLesson({ title, group, dt, fromDate, toDate,  active, numberOfLessons })
        }
    }


    
    const groupsOptions = props.groups.map(group => {
        return (
            <option
                key={group.id}
                value={group.id}
            > {group.name}</option >
        )
    })

  

    const errClass = isError ? "errmsg" : "offscreen"



    const content = (
        <>
            <p className={errClass}>{error?.data?.message}</p>

            <form className="form" onSubmit={onSaveLessonClicked}>
                <div className="form__title-row">
                    <h2>New Lesson</h2>
                    <div className="form-top-bottons">
                    <button
                            className="icon-button"
                            title="Back"
                            onClick={()=>{navigate(`/${type}/${groupId}/lessons`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                        <button
                            className="icon-button"
                            title="Save"
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                    </div>
                </div>
                <label className="form__label" htmlFor="title">
                title: </label>
                <div className="flex gap-2">
 <input
                   className={`form__input flex-1  ${!title &&'form__input--incomplete'}`}
                    id="title"
                    name="title"
                    type="text"
                    autoComplete="off"
                    value={title}
                    onChange={(e)=>setTitle(e.target.value)}
                />
                 <input
                 placeholder="Number of Lessons"
                 title="Number of Lessons"
                   className={`form__input  w-60 `}
                    id="numberOfLessons"
                    name="numberOfLessons"
                    type="Number"
                    autoComplete="off"
                    value={numberOfLessons}
                    onChange={(e)=>setNumberOfLessons(e.target.value)}
                />
                </div>
               
                 <label className="form__label" htmlFor="group">
        group:</label>
        <select
                        id="group"
                        name="group"
                        className={`form__input  ${!group &&'form__input--incomplete'}`}
                        value={group}
                        onChange={(e)=>setGroup(e.target.value)}
                    >
                        <option></option>
                        {groupsOptions}
                    </select>

                    <label className="form__label" htmlFor="dt">
                    Date:</label>
                <input
                    className={`form__input  ${!dt &&'form__input--incomplete'}`}
                    id="dt"
                    name="dt"
                    type="datetime-local"
                    autoComplete="off"
                    value= {`${dt.getFullYear().toString()}-${(dt.getMonth() + 1).toString().padStart(2, 0)}-${dt.getDate().toString().padStart(2, 0)}T${dt.getHours().toString().padStart(2, 0)}:${dt.getMinutes().toString().padStart(2, 0)}`}
                    onChange={(e)=>setDt(new Date(e.target.value))}
                />

                    <div className="form-flex">

<div className="form-input-container">
                 <label className="form__label" htmlFor="fromDatedt">
                    From Date:</label>
                <input
                    className={`form__input  ${!fromDate &&'form__input--incomplete'}`}
                    id="fromDate"
                    name="fromDate"
                    type="datetime-local"
                    autoComplete="off"
                    value= {`${fromDate.getFullYear().toString()}-${(fromDate.getMonth() + 1).toString().padStart(2, 0)}-${fromDate.getDate().toString().padStart(2, 0)}T${fromDate.getHours().toString().padStart(2, 0)}:${fromDate.getMinutes().toString().padStart(2, 0)}`}
                    onChange={(e)=>setFromDate(new Date(e.target.value))}
                />
                </div>
                <div className="form-input-container">

                <label className="form__label form__title-row" htmlFor="toDate">
                   <span> To Date:</span> <small > (<TimeLeft endtime={toDate} />)</small> </label>
                <input
                    className={`form__input  ${!toDate &&'form__input--incomplete'}`}
                    id="toDate"
                    name="toDate"
                    type="datetime-local"
                    autoComplete="off"
                    value= {`${toDate.getFullYear().toString()}-${(toDate.getMonth() + 1).toString().padStart(2, 0)}-${toDate.getDate().toString().padStart(2, 0)}T${toDate.getHours().toString().padStart(2, 0)}:${toDate.getMinutes().toString().padStart(2, 0)}`}
                    onChange={(e)=>setToDate(new Date(e.target.value))}
                />
                </div>
                </div>

                    <label className="form__label form__checkbox-container" htmlFor="user-active">
                    ACTIVE:
                    <input
                        className="form__checkbox"
                        id="user-active"
                        name="user-active"
                        type="checkbox"
                        checked={active}
                        onChange={(e)=>setActive(prev => !prev)}
                    />
                </label>

              


               
               

            </form>
        </>
    )

    return content
}
export default NewLessonForm